"use client"

import { forwardRef } from "react"

import "./index.scss"

import Link from "next/link"

import { MarketsDropdown } from "./MarketsDropdown"
import { SimpleNavItem } from "./SimpleNavItem"
import { NavigationItem } from "./type"

interface MainNavigationProps {
  items: NavigationItem[] | Record<string, NavigationItem[]>
}

/**
 * 主导航组件
 * 支持下拉菜单、热门标签、二级菜单
 */
export const MainNavigation = forwardRef<HTMLElement, MainNavigationProps>(function MainNavigation({ items }, ref) {
  // 如果 items 是数组，直接使用；如果是对象，转换为数组
  const itemsArray: NavigationItem[] = Array.isArray(items)
    ? items
    : Object.entries(items).map(([key, value]) => ({
        title: key,
        href: "#",
        children: value,
      }))

  return (
    <nav className="mainNavigation" ref={ref}>
      {itemsArray.map((item) => {
        const itemKey = item.id || (typeof item.title === "string" ? item.title : item.href)
        if (!item.children) {
          return (
            <Link
              key={itemKey}
              href={item.href}
              className="navItem"
              prefetch={false}
              {...(item.openInNewTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            >
              <span className="navItemText">{item.title}</span>
            </Link>
          )
        }

        // Markets 使用自定义两级下拉菜单
        if (item.id === "markets" && item.children.length > 0) {
          return <MarketsDropdown key={itemKey} item={item} />
        }

        // 其他菜单项使用简单下拉菜单
        return (
          <SimpleNavItem key={itemKey} item={item}>
            {item.title}
          </SimpleNavItem>
        )
      })}
    </nav>
  )
})
